<template>
  <div class="login" data-model-id="3:5454">
    <div class="login-container">
      <div class="login-left">
        <div class="login-content">
          <div class="logo-section">
            <img
              class="logo"
              alt="Florisuite Logo"
              src="https://c.animaapp.com/nNxA75tB/img/frame-402-1.svg"
            />
          </div>

          <div class="form-section">
            <div class="form-header">
              <h1 class="form-title">Connexion</h1>
              <p class="form-subtitle">Accédez à votre compte Florisuite</p>
            </div>

            <form class="login-form" @submit.prevent="handleLogin">
              <div class="form-group">
                <label class="form-label" for="email">Email</label>
                <input
                  class="form-input"
                  type="email"
                  id="email"
                  placeholder="votre.email@exemple.com"
                  required
                />
              </div>

              <div class="form-group">
                <label class="form-label" for="password">Mot de passe</label>
                <input
                  class="form-input"
                  type="password"
                  id="password"
                  placeholder="••••••••"
                  required
                />
              </div>

              <div class="form-options">
                <label class="checkbox-label">
                  <input type="checkbox" class="checkbox-input" />
                  <span>Se souvenir de moi</span>
                </label>
                <RouterLink to="/mot-de-passe-oublie" class="forgot-link">
                  Mot de passe oublié ?
                </RouterLink>
              </div>

              <button class="submit-button" type="submit">
                <span class="button-text">Se connecter</span>
              </button>
            </form>

            <div class="signup-prompt">
              <span class="prompt-text">Vous n'avez pas de compte ?</span>
              <RouterLink to="/inscription" class="signup-link">
                Créer un compte
              </RouterLink>
            </div>
          </div>
        </div>
      </div>

      <div class="login-right">
        <div class="hero-content">
          <h2 class="hero-title">Bienvenue sur Florisuite</h2>
          <p class="hero-description">
            La plateforme tout-en-un pour gérer votre commerce floral avec simplicité et efficacité.
          </p>
          <img
            class="hero-image"
            alt="Florisuite Dashboard"
            src="https://c.animaapp.com/nNxA75tB/img/image.png"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RouterLink } from "vue-router";

export default defineComponent({
  name: "Login",
  components: {
    RouterLink,
  },
  methods: {
    handleLogin() {
      alert("Connexion en cours... (Démo uniquement)");
    },
  },
});
</script>

<style>
.login {
  align-items: center;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  position: relative;
  width: 100%;
}

.login .login-container {
  align-items: stretch;
  display: flex;
  height: 100vh;
  max-width: 1440px;
  width: 100%;
}

.login .login-left {
  align-items: center;
  background-color: #ffffff;
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 60px 40px;
}

.login .login-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 48px;
  max-width: 480px;
  width: 100%;
}

.login .logo-section {
  align-self: flex-start;
}

.login .logo {
  height: 40px;
  width: auto;
}

.login .form-section {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}

.login .form-header {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.login .form-title {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 40px;
}

.login .form-subtitle {
  align-self: stretch;
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
}

.login .login-form {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.login .form-group {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.login .form-label {
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
}

.login .form-input {
  align-self: stretch;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  box-sizing: border-box;
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
  padding: 12px 16px;
  transition: border-color 0.2s ease;
  width: 100%;
}

.login .form-input:focus {
  border-color: #084734;
  outline: none;
}

.login .form-input::placeholder {
  color: #9ca3af;
}

.login .form-options {
  align-items: center;
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.login .checkbox-label {
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 8px;
}

.login .checkbox-input {
  cursor: pointer;
  height: 16px;
  width: 16px;
}

.login .checkbox-label span {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
}

.login .forgot-link {
  color: #084734;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  text-decoration: none;
}

.login .forgot-link:hover {
  text-decoration: underline;
}

.login .submit-button {
  all: unset;
  align-self: stretch;
  background-color: #084734;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  cursor: pointer;
  height: 48px;
  overflow: hidden;
  padding: 12px 32px;
  position: relative;
  text-align: center;
  transition: all 0.2s ease;
}

.login .submit-button:hover {
  background-color: #0a5a42;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
}

.login .button-text {
  color: #ffffff;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
}

.login .signup-prompt {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 8px;
  justify-content: center;
}

.login .prompt-text {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
}

.login .signup-link {
  color: #084734;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  text-decoration: none;
}

.login .signup-link:hover {
  text-decoration: underline;
}

.login .login-right {
  align-items: center;
  background: linear-gradient(135deg, #084734 0%, #0a5a42 100%);
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 60px 40px;
}

.login .hero-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 500px;
  width: 100%;
}

.login .hero-title {
  align-self: stretch;
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 45px;
  text-align: center;
}

.login .hero-description {
  align-self: stretch;
  color: #d2f1ba;
  font-family: "Open Sans", Helvetica;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 28px;
  text-align: center;
}

.login .hero-image {
  align-self: stretch;
  border-radius: 12px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
  width: 100%;
}

@media (max-width: 1024px) {
  .login .login-container {
    flex-direction: column;
    height: auto;
  }

  .login .login-right {
    display: none;
  }
}
</style>
